import { TInquiriesDetailsData } from "@/interfaces";

const TravelBanInquiryDetails = ({ data }: { data: TInquiriesDetailsData }) => {
  return <div>InquiryDetails</div>;
};

export default TravelBanInquiryDetails;
